var _path, _rect, _rect2, _path2, _path3, _rect3, _rect4, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCfSingle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 22,
    viewBox: "0 0 42 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.26087 0.824684C6.15991 0.824684 7.69705 2.36154 7.69705 4.26087C7.69705 6.15991 6.1602 7.69705 4.26087 7.69705C2.36183 7.69705 0.824684 6.1602 0.824684 4.26087C0.824684 2.36183 2.36154 0.824684 4.26087 0.824684ZM4.26087 0C1.90765 0 0 1.90765 0 4.26087C0 6.61409 1.90765 8.52174 4.26087 8.52174C6.61409 8.52174 8.52174 6.61409 8.52174 4.26087C8.52174 1.90765 6.61409 0 4.26087 0ZM4.26087 2.8864C3.50176 2.8864 2.8864 3.50176 2.8864 4.26087C2.8864 5.01997 3.50176 5.63534 4.26087 5.63534C5.01997 5.63534 5.63534 5.01997 5.63534 4.26087C5.63534 3.50176 5.01997 2.8864 4.26087 2.8864Z",
    fill: "#97B1F1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.9565,
    y: 1.21741,
    width: 30.4348,
    height: 5.47826,
    rx: 2.73913,
    fill: "#97B1F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9565,
    y: 14,
    width: 30.4348,
    height: 5.47826,
    rx: 2.73913,
    fill: "#97B1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.26087 12.1738C1.90708 12.1738 0 14.0809 0 16.4347C0 18.7885 1.90708 20.6956 4.26087 20.6956C6.61466 20.6956 8.52174 18.7885 8.52174 16.4347C8.52174 14.0809 6.61466 12.1738 4.26087 12.1738ZM4.26087 19.8709C2.36238 19.8709 0.824684 18.3332 0.824684 16.4347C0.824684 14.5362 2.36238 12.9985 4.26087 12.9985C6.15936 12.9985 7.69705 14.5362 7.69705 16.4347C7.69705 18.3332 6.15936 19.8709 4.26087 19.8709Z",
    fill: "#97B1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86976 1.43333C6.7688 1.43333 8.30594 2.97018 8.30594 4.86951C8.30594 6.76855 6.76909 8.3057 4.86976 8.3057C2.97071 8.3057 1.43357 6.76885 1.43357 4.86951C1.43357 2.97047 2.97042 1.43333 4.86976 1.43333ZM4.86976 0.608643C2.51654 0.608643 0.608887 2.51629 0.608887 4.86951C0.608887 7.22273 2.51654 9.13038 4.86976 9.13038C7.22298 9.13038 9.13063 7.22273 9.13063 4.86951C9.13063 2.51629 7.22298 0.608643 4.86976 0.608643ZM4.86976 3.49504C4.11065 3.49504 3.49528 4.11041 3.49528 4.86951C3.49528 5.62862 4.11065 6.24399 4.86976 6.24399C5.62886 6.24399 6.24423 5.62862 6.24423 4.86951C6.24423 4.11041 5.62886 3.49504 4.86976 3.49504Z",
    fill: "#CBD8F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5654,
    y: 1.82605,
    width: 30.4348,
    height: 5.47826,
    rx: 2.73913,
    fill: "#CBD8F8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5654,
    y: 14.6086,
    width: 30.4348,
    height: 5.47826,
    rx: 2.73913,
    fill: "#CBD8F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86976 12.7826C2.51597 12.7826 0.608887 14.6897 0.608887 17.0435C0.608887 19.3972 2.51597 21.3043 4.86976 21.3043C7.22354 21.3043 9.13063 19.3972 9.13063 17.0435C9.13063 14.6897 7.22354 12.7826 4.86976 12.7826ZM4.86976 20.4796C2.97126 20.4796 1.43357 18.942 1.43357 17.0435C1.43357 15.145 2.97126 13.6073 4.86976 13.6073C6.76825 13.6073 8.30594 15.145 8.30594 17.0435C8.30594 18.942 6.76825 20.4796 4.86976 20.4796Z",
    fill: "#CBD8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfSingle);
export default __webpack_public_path__ + "static/media/cf-single.0782d72868a3a9724c107f5a7777e3af.svg";
export { ForwardRef as ReactComponent };